export enum PurchaseTypes {
    NEW = 'NEW',
    ADDITIONAL = 'ADDITIONAL',
    SWITCH = 'SWITCH',
    REDEMPTION = 'REDEMPTION',
    SIP = 'SIP',
    SUBMIT_SIP_PAUSE_CANCEL ='SUBMIT_SIP_PAUSE_CANCEL',
    SIP_PAUSE_CANCEL ='SIP_PAUSE_CANCEL',
    STP = 'STP_REGISTRATION',
    SWP = 'SWP_REGISTRATION',
    PROSPECT_FOLIO = 'PROSPECT_FOLIO',
    OTM_CANCEL = 'SUBMIT_OTM_CANCEL'
}

export type List = {
    label: string;
    dataKey: string;
    type?: 'currency' | 'date';
    valueGetter?: (data: any) => string;
};
